import { useState } from "react";

const useReviewHandler = (idToken) => {
  const [reviewLoading, setReviewLoading] = useState(false);

  const handleReview = async (recommendation, showId) => {
    
    setReviewLoading(true);

    try {
      const response = await fetch(
        `https://script.google.com/macros/s/AKfycbxREPDO9_xArVTVk3trXhFg-u76nPzCES2MoIyBtsUPy7xTGYoNRClNu-AMkltdCSZx/exec?action=addreview`,
        {
          method: "POST",
          body: JSON.stringify({
            id_token: idToken,
            show_unique_id: showId,
            recommended: recommendation,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();

      if (data.status !== "success") {
        throw new Error("API error");
      }

      setReviewLoading(false);

      return true;

    } catch (error) {

      console.error("Error adding review:", error);
      setReviewLoading(false);

      return false;
    }
  };

  return [reviewLoading, handleReview];
};

export default useReviewHandler;
